import React from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { SidepanelNavbar as SidepanelNavbarRoot } from "../../styles";
import { ChatIcon, ClockIcon, UsersIcon, HelpIcon } from "Components/DumontSidebar/CustomIcons";
import { NavItem, NavItemText, HelpButton } from "./styled";
import { dumontColors } from "../../colors";

type ActiveView = "chat" | "history" | "agents";

export interface SidepanelNavbarProps {
  activeView: ActiveView;
  onNewChat: () => void;
  onHistory: () => void;
  onAgents: () => void;
  onHelpClick: () => void;
  className?: string;
}

export default function SidepanelNavbar({
  activeView,
  onNewChat,
  onHistory,
  onAgents,
  onHelpClick,
  className,
}: SidepanelNavbarProps) {
  const { t: translate } = useTranslation();

  return (
    <SidepanelNavbarRoot className={className}>
      <Stack
        spacing={2}
        alignItems="center"
        sx={{ height: "100%", justifyContent: "space-between", paddingBottom: "12px" }}
      >
        <Stack spacing={2} alignItems="center">
          <NavItem onClick={onNewChat} isActive={activeView === "chat"}>
            <ChatIcon
              sx={{ fontSize: 14, color: activeView === "chat" ? dumontColors.primary : dumontColors.textTertiary, mb: 0.5 }}
            />
            <NavItemText isActive={activeView === "chat"}>{translate("dumontNewChat")}</NavItemText>
          </NavItem>

          <NavItem onClick={onHistory} isActive={activeView === "history"}>
            <ClockIcon
              sx={{ fontSize: 14, color: activeView === "history" ? dumontColors.primary : dumontColors.textTertiary, mb: 0.5 }}
            />
            <NavItemText isActive={activeView === "history"}>{translate("dumontHistory")}</NavItemText>
          </NavItem>

          <NavItem onClick={onAgents} isActive={activeView === "agents"}>
            <UsersIcon
              sx={{ fontSize: 14, color: activeView === "agents" ? dumontColors.primary : dumontColors.textTertiary, mb: 0.5 }}
            />
            <NavItemText isActive={activeView === "agents"}>{translate("dumontAgents")}</NavItemText>
          </NavItem>
        </Stack>

        {/* <HelpButton onClick={onHelpClick}>
          <HelpIcon sx={{ fontSize: 24, color: dumontColors.textTertiary }} />
        </HelpButton> */}
      </Stack>
    </SidepanelNavbarRoot>
  );
}
